@if (formGroup) {
  @if (formGroup.get(formGroupOrControlName); as control) {
    <div [formGroup]="formGroup" class="mat-form-field-wrapper">
      <app-field-label [for]="formGroupOrControlName">{{ getLabel() }}</app-field-label>
      <div class="controls">
        <button nz-button (click)="executeCommand('bold'); $event.preventDefault()">
          <span nz-icon nzType="bold" nzTheme="outline"></span>
        </button>
        <button nz-button (click)="executeCommand('italic'); $event.preventDefault()">
          <span nz-icon nzType="italic" nzTheme="outline"></span>
        </button>
        <button nz-button (click)="executeCommand('underline'); $event.preventDefault()">
          <span nz-icon nzType="underline" nzTheme="outline"></span>
        </button>
        <ng-template #fgColorMenu>
          <button nz-button nzType="primary" [style.background-color]="fgColor">
            <span nz-icon nzType="font-colors" nzTheme="outline"></span>
          </button>
        </ng-template>
        <nz-color-picker
          [nzFlipFlop]="fgColorMenu"
          (mousedown)="captureSelection()"
          (nzOnChange)="applyColor('color', $event)"
        ></nz-color-picker>
        <ng-template #bgColorMenu>
          <button nz-button nzType="primary" [style.background-color]="bgColor">
            <span nz-icon nzType="bg-colors" nzTheme="outline"></span>
          </button>
        </ng-template>
        <nz-color-picker
          [nzFlipFlop]="bgColorMenu"
          (mousedown)="captureSelection()"
          (nzOnChange)="applyColor('backgroundColor', $event)"
        ></nz-color-picker>
        <button nz-button (click)="executeCommand('justifyLeft'); $event.preventDefault()">
          <span nz-icon nzType="align-left" nzTheme="outline"></span>
        </button>
        <button
          nz-button
          (click)="executeCommand('justifyCenter'); $event.preventDefault()"
          >
          <span nz-icon nzType="align-center" nzTheme="outline"></span>
        </button>
        <button nz-button (click)="executeCommand('justifyRight'); $event.preventDefault()">
          <span nz-icon nzType="align-right" nzTheme="outline"></span>
        </button>
        <button
          nz-button
          (click)="executeCommand('insertUnorderedList'); $event.preventDefault()"
          >
          <span nz-icon nzType="unordered-list" nzTheme="outline"></span>
        </button>
        <button
          nz-button
          (click)="executeCommand('insertOrderedList'); $event.preventDefault()"
          >
          <span nz-icon nzType="ordered-list" nzTheme="outline"></span>
        </button>
        <button
          nz-button
          (click)="executeCommand('indent'); $event.preventDefault()"
          nz-tooltip="Increase indent"
          >
          <span nz-icon nzType="right" nzTheme="outline"></span>
        </button>
        <button
          nz-button
          (click)="executeCommand('outdent'); $event.preventDefault()"
          nz-tooltip="Decrease indent"
          >
          <span nz-icon nzType="left" nzTheme="outline"></span>
        </button>
        <button
          nz-button
          (click)="changeFontSize('increase'); $event.preventDefault()"
          nz-tooltip="Increase font size"
          >
          <span nz-icon nzType="font-size" nzTheme="outline"></span>
        </button>
        <button
          nz-button
          (click)="changeFontSize('decrease'); $event.preventDefault()"
          nz-tooltip="Decrease font size"
          >
          <span nz-icon nzType="font-size" nzTheme="outline"></span>
        </button>
        <button
          nz-button
          [nzType]="resizeMode ? 'primary' : 'default'"
          (click)="toggleResizeMode(); $event.preventDefault()"
          nz-tooltip="Toggle image resize mode"
          >
          <span nz-icon nzType="arrows-alt" nzTheme="outline"></span>
        </button>
        <button nz-button (click)="executeCommand('removeFormat'); $event.preventDefault()">
          <span
            nz-icon
            nzType="clear"
            nzTheme="outline"
            nz-tooltip="Clear formatting"
          ></span>
        </button>
      </div>
      <div class="wrapper">
        <div
          class="rich-text"
          #editor
          contenteditable="true"
          (paste)="handlePaste($event)"
          (input)="handleInput()"
          (blur)="handleBlur($event)"
          (focus)="handleFocus($event)"
        ></div>
      </div>
      @if (control.errors && control.touched) {
        <app-field-error>
          {{ curateValidationHint(control) }}
        </app-field-error>
      }
    </div>
  }
}
